import { NIGHTLY_RATES_TO_BOLD_COUNT } from '~/constants/campground'

import type { Campground } from '~/types/rental-api-aliases'
import type { CampgroundAveragePrice } from '~/types/campground'

/**
 * Returns the average price of the campground.
 *
 * @param nightlyRates The nightly rates of the campground.
 * @returns The average price of the campground.
 *
 * @example getCampgroundAveragePrice('Free') // { isFree: true, boldCount: 0, text: '' }
 * @example getCampgroundAveragePrice('Lowest') // { isFree: false, boldCount: 1, text: '$' }
 * @example getCampgroundAveragePrice('Highest') // { isFree: false, boldCount: 5, text: '$$$$$' }
 */
export function getCampgroundAveragePrice(
  nightlyRates: Campground['NightlyRates'],
): CampgroundAveragePrice {
  if (!nightlyRates) {
    return
  }

  if (nightlyRates === 'Free') {
    return { isFree: true, boldCount: 0, text: '' }
  }

  const boldCount = NIGHTLY_RATES_TO_BOLD_COUNT[nightlyRates] ?? 0
  return {
    isFree: false,
    boldCount: Math.min(5, Math.max(0, boldCount)),
    text: '$'.repeat(boldCount),
  }
}
